import { render, staticRenderFns } from "./ProductsTableComponent.vue?vue&type=template&id=dd595a76"
import script from "./ProductsTableComponent.vue?vue&type=script&lang=js"
export * from "./ProductsTableComponent.vue?vue&type=script&lang=js"
import style0 from "./ProductsTableComponent.vue?vue&type=style&index=0&id=dd595a76&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports